/**
 * 对接道具好友推荐通用mixins
 */

import { FriendRecommendApi } from "@api/friendRecomm"
import { mapGetters, mapActions } from "vuex"

export default {
  data() {
    return {
      friendRecommObj: null,
      isRateRecomm: null,
      isBuyRecomm: null,
      userRecommInfo: null
    }
  },
  computed: {
    ...mapGetters(["currentItem", "vmallConfigByAMSID", "offerId", "sessionObj", "sandbox", "pf", "userAgent"]),
    // 如果用户购买推荐过，则结果页不展示推荐入口
    // 如果用户评分推荐过，则结果页不展示推荐入口
    // 如果没有购买推荐和评分推荐过，才展示推荐入口
    // 在重复购买的场景下,只要命中一种种草行为(购买或评分）,就不再展示了
    checkShowBuyRecomm() {
      // 目前只支持王者业务
      if (
        !this.userAgent.qqtim &&
        this.currentItem?.busId * 1 == 2 &&
        !this.isBuyRecomm &&
        !this.isRateRecomm &&
        !this.isOuterScene &&
        this.isBuyRecomm !== null &&
        this.isRateRecomm !== null
      ) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapActions(["reportUserAction"]),
    /**
     * 结果页查询用户推荐状态
     * @param {*}
     */
    async getUserPropRecomm(subjectId) {
      if (this.currentItem?.busId * 1 == 2 && !this.isOuterScene) {
        // 获取接口调用接口
        if (!this.friendRecommObj) {
          this.friendRecommObj = new FriendRecommendApi({
            pf: this.pf,
            sandbox: this.sandbox,
            sessionObj: this.sessionObj,
            // 因为推荐位道具推荐，优先取道具offerid
            offerId: this.currentItem?.ams?.offerid || this.offerId
          })
        }

        let res = await this.friendRecommObj.queryUserReocmmStatus({
          subject_id: subjectId
        })

        if (res?.ret == 0 && res?.data) {
          this.userRecommInfo = res?.data
          this.isBuyRecomm = res.data?.show_buy == "1" && res.data?.buy == "1"
          this.isRateRecomm = res.data?.show_score == "1" && parseFloat(res.data?.score) > 0
          return res.data
        } else {
          return null
        }
      }
    },

    /**
     *
     * @param {*} subjectId
     * @param {*} behavior
     * show_thumbs 点赞推荐
     * @returns
     */
    async handlePropsRecomm({ subjectId, behavior }) {
      if (!this.friendRecommObj) {
        this.friendRecommObj = new FriendRecommendApi({
          pf: this.pf,
          sandbox: this.sandbox,
          sessionObj: this.sessionObj,
          offerId: this.currentItem?.ams?.offerid || this.offerId
        })
      }

      let res = await this.friendRecommObj.recommPropsAction({
        subject_id: subjectId,
        behavior: behavior
      })

      if (res?.ret == 0) {
        return "success"
      } else {
        return "fail"
      }
    }
  }
}
